import { render, staticRenderFns } from "./sendFoucusStrategy.vue?vue&type=template&id=4f7165ba&"
import script from "./sendFoucusStrategy.vue?vue&type=script&lang=js&"
export * from "./sendFoucusStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports